<template>
<div class="">
  <v-btn :depressed="true" color="default" block @click="showThumbnail = true">Thumbnail Image</v-btn>
  <div class="">
    <img :src="singleFacility.thumbnail" alt="" width="100%">
    <my-upload
      field="file"
      v-model="showThumbnail"
      :width="830"
      :height="526"
      :url="thumbnailUrl()"
      @crop-upload-success="imageuploaded"
      :noCircle="true"
      lang-type="en">
    </my-upload>
  </div>
  <v-btn color="error" block @click="removeThumbnailImage()">Remove Thumbnail Image</v-btn>
  <br>
  <v-btn :depressed="true" color="default" block @click="showImages = true">Facility Images</v-btn>
  <div class="">
    <div class="contact-stat">
      <my-upload
        field="file"
        v-model="showImages"
        :width="1904"
        :height="830"
        :url="majorImageUrl()"
        @crop-upload-success="otherImages"
        :noCircle="true"
        lang-type="en">
      </my-upload>
    </div>
    <div class="row">
      <div class="col-md-4" v-for="(image, key) in facilityImages" :key="key">
        <img :src="image.path" alt="" width="100%">
        <v-btn :depressed="true" small @click="removeImage(image.public_id)" block color="error">Remove</v-btn>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
export default {
  name: 'facility-images',
  data () {
    return {
      showThumbnail: false,
      showImages: false
    }
  },
  components: {
    myUpload
  },
  methods: {
    removeImage (imageId) {
      var data = {
        public_id: imageId,
        facility_id: this.$route.params.facility_id
      }
      this.$store.dispatch('delete_facility_image', data)
    },
    removeThumbnailImage () {
      this.$store.dispatch('delete_thumbnail_facility_image', this.$route.params.facility_id)
      
    },
    otherImages: function () {
      this.$store.dispatch('get_facility_images', this.$route.params.facility_id)
    },
    imageuploaded: function () {
      this.$store.dispatch('get_facility', this.$route.params.facility_id)
    },
    thumbnailUrl: function () {
      return this.$imageUniversalUrl() + ':5001/facility/thumbnail/' + this.$route.params.facility_id
    },
    majorImageUrl: function () {
      return this.$imageUniversalUrl() + ':5001/facility/image/' + this.$route.params.facility_id
    }
  }
}
</script>

<style scoped>

</style>
